/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}         from '@/util/i.command';
import {TSOEditor}        from './t.s.o.editor';
import {TrainClass}       from '@/models/scenario/train.class';

/**
 *
 * @class SetFRTClassesCommand
 *
 * @brief reversible updates of the tso freight classes
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetFRTClassesCommand implements ICommand {

  private oldValue: TrainClass[];
  private newValue: TrainClass[];
  private editor:   TSOEditor;

  constructor(oldValue: TrainClass[], newValue: TrainClass[], editor: TSOEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setFRTClasses(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setFRTClasses(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[frt classes] ' + JSON.stringify(this.oldValue.map(x => x._name)) + ' => ' + JSON.stringify(this.newValue.map(x => x._name));
  }

}
